<script setup lang="ts">
const props = defineProps<{
  post?: PostItem | null;
}>();

const markers = ref<
  { data?: any; marker: google.maps.marker.AdvancedMarkerElementOptions }[]
>([]);

const { getPostTypeIconComponent } = usePostTypes();
const { getPaletteForPostType } = useTheme();

const currentPalette = computed(() => getPaletteForPostType(props.post?.type));

const { createMarkerContent } = useGoogleMapsMarker();

const position = computed(() => ({
  lat: (props.post?.location_map_marker?.coordinates?.[1] as number) || 0,
  lng: (props.post?.location_map_marker?.coordinates?.[0] as number) || 0,
}));

const setMarker = () => {
  markers.value = [
    {
      data: props.post,
      marker: {
        position: position.value,
        title: props.post?.title || "",
        gmpClickable: false,
        gmpDraggable: false,
        content: createMarkerContent({
          postType: props.post?.type,
        }),
      },
    },
  ];
};

onMounted(setMarker);
</script>

<template>
  <section
    v-if="props.post?.location_map_enabled && props.post.location_map_marker"
    class="post-location"
  >
    <div class="post-location__container container">
      <div
        class="post-location__wrapper flex flex-col items-stretch gap-8 lg:gap-10"
      >
        <div class="post-location__title">
          <h2
            class="text-[1.75rem] leading-[1.5rem] lg:text-[3.125rem] lg:leading-[2.75rem]"
          >
            <span class="inline">Zobacz</span>
            <span class="inline tracking-[0.25rem]">&emsp14;</span>
            <span class="inline font-display tracking-[0.3125rem]"
              >na mapie</span
            >
          </h2>
        </div>

        <div
          class="post-location__content relative w-full h-[19.25rem] lg:h-[28.5rem]"
        >
          <AppMap
            class="block !w-full !h-full border-[0.0625rem] border-[#F1F1F1]"
            :options="{
              center: position,
              mapId: 'a3a2ac208fdd4128',
              zoom: 10,
              clickableIcons: false,
            }"
            :markers="markers"
          >
            <template #marker="{ data }">
              <AppMapMarker
                tag="div"
                :bg-class="currentPalette.bg"
                :title="data?.title"
              >
                <component
                  :is="data?.type ? getPostTypeIconComponent(data.type) : 'div'"
                />
              </AppMapMarker>
            </template>
          </AppMap>
        </div>
      </div>
    </div>
  </section>
</template>
